<template>
  <!-- Main content -->
  <section class="content">
    <!-- Info boxes -->
    <div class="row">
      <!--<div class="alert alert-success alert-dismissible">-->
        <!--<button type="button" class="close" data-dismiss="alert" aria-hidden="true">&times;</button>-->
        <!--<h4><i class="icon fa fa-check"></i> CoPilot is open source!</h4>-->
        <!--Click on icon to check it out on github. <a href="https://github.com/misterGF/CoPilot" target="_blank"><i class="fa fa-github fa-2x"></i></a>-->
      <!--</div>-->
      <!-- 今日訂單數 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType != 99" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-aqua"><i class="ion ion-document-text"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">今日已完成訂單數</span>
            <span class="info-box-number text-35">{{ordersAmount.today.amount}}</span>
          </div>
        </div>
      </div>
      <!-- 今日成交金額-->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-green"><i class="ion ion-cash"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">今日成交金額</span>
            <span class="info-box-number text-35">{{ordersAmount.today.money}}</span>
          </div>
        </div>
      </div>
      <!-- /.col -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType == 99">
        <div class="info-box">
          <span class="info-box-icon bg-red"><i class="ion ion-ios-people"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">總會員</span>
            <span class="info-box-number text-35">{{shoppersAmount}}</span>
          </div>
          <!-- /.info-box-content -->
        </div>
        <!-- /.info-box -->
      </div>
      <!-- 今日退訂金額 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType != 99" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-red"><i class="ion ion-heart-broken"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">今日退訂金額</span>
            <span class="info-box-number text-35">{{disAmount.today}}</span>
          </div>
        </div>
      </div>
      <!-- 今日賣出份數 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType != 99" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-light-blue"><i class="ion ion-wineglass"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">今日賣出份數</span>
            <span class="info-box-number text-35">{{successItem.today}}</span>
          </div>
        </div>
      </div>
      <!-- 今日錯誤筆數-->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType != 99" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-yellow"><i class="ion ion-sad"></i></span>

          <div class="info-box-content">
            <span class="info-box-text m-t-5">今日未完成筆數</span>
            <span class="info-box-number text-35">{{errorAmount.today}}</span>
          </div>
        </div>
      </div>
      <!-- 累積總訂單數-->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-aqua"><i class="ion ion-document-text"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積總訂單數</span>
            <span class="info-box-number text-35">{{ordersAmount.total.amount}}</span>
          </div>
        </div>
      </div>
      <!-- 累積總成交金額-->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType != 99" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-green"><i class="ion ion-cash"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積成交金額</span>
            <span class="info-box-number text-35">{{ordersAmount.total.money}}</span>
          </div>
        </div>
      </div>
      <!-- 累積退訂金額 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType != 99" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-red"><i class="ion ion-heart-broken"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積退訂金額</span>
            <span class="info-box-number text-35">{{disAmount.total}}</span>
          </div>
        </div>
      </div>
      <!-- 累積賣出份數 -->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" v-if="roleType != 99" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-light-blue"><i class="ion ion-wineglass"></i></span>
          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積賣出份數</span>
            <span class="info-box-number text-35">{{successItem.total}}</span>
          </div>
        </div>
      </div>
      <!-- 累積錯誤筆數-->
      <div class="col-lg-3 col-sm-6 col-xs-12 p-x-10" :class="{'col-lg-20-p': roleType !=99}">
        <div class="info-box">
          <span class="info-box-icon bg-yellow"><i class="ion ion-sad"></i></span>

          <div class="info-box-content">
            <span class="info-box-text m-t-5">累積錯誤筆數</span>
            <span class="info-box-number text-35">{{errorAmount.total}}</span>
          </div>
        </div>
      </div>
      <!-- 即時訂單列表-->
      <div class="col-xs-12 p-10">
        <div class="col-xs-12 col-md-6 p-r-10">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">即時訂單狀態數量統計</h3>
              <br><br>
              <div class="col-xs-12">
                <canvas id="all-amount-brief" height="100"></canvas>
              </div>
              <div class="col-xs-12 table-responsive" style="overflow: scroll; max-height: 500px;">
                <br>
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th>總訂單</th>
                    <th>未接單</th>
                    <th>已接單</th>
                    <th>被退訂</th>
                    <th>已完成</th>
                    <th>已作廢</th>
                  </tr>

                  </thead>
                  <tbody>
                  <tr class="even" role="row">
                    <td>{{allStatistic.total.amount}}筆</td>
                    <td>{{allStatistic.noAccept.amount}}筆</td>
                    <td>{{allStatistic.accept.amount}}筆</td>
                    <td>{{allStatistic.refuse.amount}}筆</td>
                    <td>{{allStatistic.done.amount}}筆</td>
                    <td>{{allStatistic.del.amount}}筆</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-md-6 p-l-10">
          <div class="box">
            <div class="box-header with-border">
              <h3 class="box-title">即時訂單狀態金額統計</h3>
              <br><br>
              <div class="col-xs-12">
                <canvas id="all-money-brief" class="small-pie" height="100"></canvas>
              </div>
              <div class="col-xs-12 table-responsive" style="overflow: scroll; max-height: 500px;">
                <br>
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <thead>
                  <tr role="row">
                    <th>總訂單</th>
                    <th>未接單</th>
                    <th>已接單</th>
                    <th>被退訂</th>
                    <th>已完成</th>
                    <th>已作廢</th>
                  </tr>

                  </thead>
                  <tbody>
                  <tr class="even" role="row">
                    <td>{{allStatistic.total.money}}元</td>
                    <td>{{allStatistic.noAccept.money}}元</td>
                    <td>{{allStatistic.accept.money}}元</td>
                    <td>{{allStatistic.refuse.money}}元</td>
                    <td>{{allStatistic.done.money}}元</td>
                    <td>{{allStatistic.del.money}}元</td>
                  </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10" v-if="roleType == 99 && topOrderAmount.brand">
        <div class="box">
          <div class="box-header with-border">
            <h3 class="box-title">品牌成交量前五名</h3>
            <br><br>
            <div class="box-body">
              <div class="col-xs-12 text-center" v-if="topOrderAmount.brand.length !== 1">
                <!--<canvas id="today-brand-top"></canvas>-->
                <div><img src="/static/img/crown.png"></div>
                <h3 class="text-yellow">{{topOrderAmount.brand[0].brand_name}}</h3>
              </div>
              <div class="col-xs-12" v-if="topOrderAmount.brand.length !== 1">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <tbody>
                  <tr class="even" role="row" v-for="(brand, index) in topOrderAmount.brand" v-if="index + 1 != topOrderAmount.brand.length">
                    <td>
                      No.{{index + 1}}
                    </td>
                    <td>
                      {{brand.brand_name}}
                    </td>
                    <td class="hidden-xs">
                      {{brand.amount}} 筆
                    </td>
                    <td class="hidden-xs" v-if="roleType == 30">
                      {{brand.money}} 元
                    </td>
                    <td class="hidden-xs" v-if="roleType == 30">
                      {{brand.item_count}} 份
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-xs-12 text-right">
                <h6>其餘品牌共 {{topOrderAmount.brand[topOrderAmount.brand.length - 1].amount}} 筆</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10" v-if="roleType == 99 && topOrderAmount.store">
        <div class="box" v-if="topOrderAmount.store.length">
          <div class="box-header with-border">
            <h3 class="box-title"><span v-if="roleType == 30">今日</span>店家成交量前五名</h3>
            <br><br>
            <div class="box-body">
              <div class="col-xs-12 text-center" v-if="topOrderAmount.store.length !== 1">
                <div><img src="/static/img/crown.png"></div>
                <h3 v-if="roleType === 99" class="text-yellow">{{topOrderAmount.store[0].brand_name}} - {{topOrderAmount.store[0].store_name}}</h3>
                <h3 v-if="roleType === 30" class="text-yellow">{{topOrderAmount.store[0].store_name}}</h3>
                <!--<canvas id="today-store-top"></canvas>-->
              </div>
              <div class="col-xs-12" v-if="topOrderAmount.store.length !== 1">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <tbody>
                  <tr class="even" role="row" v-for="(store, index) in topOrderAmount.store" v-if="index + 1 != topOrderAmount.store.length">
                    <td>
                      No.{{index + 1}}
                    </td>
                    <td>
                      <span v-if="roleType === 99">{{store.brand_name}} - {{store.store_name}}</span>
                      <span v-if="roleType === 30">{{store.store_name}}</span>
                    </td>
                    <td class="hidden-xs">
                      {{store.amount}} 筆
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-xs-12 text-right">
                <h6>其餘店家共 {{topOrderAmount.store[topOrderAmount.store.length - 1].amount}} 筆</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10" v-if="roleType == 30 && topTradeMoney.store">
        <div class="box" v-if="topTradeMoney.store.length">
          <div class="box-header with-border">
            <h3 class="box-title"><span v-if="roleType == 30">今日</span>店家成交金額前五名</h3>
            <br><br>
            <div class="box-body">
              <div class="col-xs-12 text-center" v-if="topTradeMoney.store.length !== 1">
                <div><img src="/static/img/crown.png"></div>
                <h3 class="text-yellow">{{topTradeMoney.store[0].store_name}}</h3>
                <!--<canvas id="today-store-top"></canvas>-->
              </div>
              <div class="col-xs-12" v-if="topTradeMoney.store.length !== 1">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <tbody>
                  <tr class="even" role="row" v-for="(store, index) in topTradeMoney.store" v-if="index + 1 != topTradeMoney.store.length">
                    <td>
                      No.{{index + 1}}
                    </td>
                    <td>
                      <span v-if="roleType === 99">{{store.brand_name}} - {{store.store_name}}</span>
                      <span v-if="roleType === 30">{{store.store_name}}</span>
                    </td>
                    <td class="hidden-xs">
                      {{store.money}} 元
                    </td>
                    <td class="hidden-xs">
                      {{store.order_count}} 筆
                    </td>
                    <td class="hidden-xs">
                      {{store.item_count}} 份
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-xs-12 text-right">
                <h6>其餘店家共 {{topTradeMoney.store[topTradeMoney.store.length - 1].money}} 元</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12 col-md-6 p-10" v-if="roleType == 30 && topRejectedMoney.store">
        <div class="box" v-if="topRejectedMoney.store.length">
          <div class="box-header with-border">
            <h3 class="box-title"><span v-if="roleType == 30">今日</span>店家退訂金額前五名</h3>
            <br><br>
            <div class="box-body">
              <div class="col-xs-12 text-center" v-if="topRejectedMoney.store.length !== 1">
                <div><img src="/static/img/crying.png"></div>
                <h3 class="text-yellow">{{topRejectedMoney.store[0].store_name}}</h3>
                <!--<canvas id="today-store-top"></canvas>-->
              </div>
              <div class="col-xs-12" v-if="topRejectedMoney.store.length !== 1">
                <table aria-describedby="example1_info" role="grid" class="table table-bordered table-striped dataTable">
                  <tbody>
                  <tr class="even" role="row" v-for="(store, index) in topRejectedMoney.store" v-if="index + 1 != topRejectedMoney.store.length">
                    <td>
                      No.{{index + 1}}
                    </td>
                    <td>
                      <span v-if="roleType === 99">{{store.brand_name}} - {{store.store_name}}</span>
                      <span v-if="roleType === 30">{{store.store_name}}</span>
                    </td>
                    <td class="hidden-xs">
                      {{store.money}} 元
                    </td>
                    <td class="hidden-xs">
                      {{store.order_count}} 筆
                    </td>
                    <td class="hidden-xs">
                      {{store.item_count}} 份
                    </td>
                  </tr>
                  </tbody>
                </table>
              </div>
              <div class="col-xs-12 text-right">
                <h6>其餘店家共 {{topRejectedMoney.store[topRejectedMoney.store.length - 1].money}} 元</h6>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-xs-12" v-if="roleType == 99">

      </div>
      <div class="col-xs-12" v-if="roleType == 99">
        <div>
          <system-dashboard></system-dashboard>
        </div>
      </div>
      <div class="col-xs-12" v-if="roleType == 30">
        <div>
          <brand-dashboard></brand-dashboard>
        </div>
      </div>
      <div class="col-xs-12" v-if="roleType == 10">
        <order-line-charts />
      </div>
      <!--
      <div class="col-xs-12 p-l-10">
        <reject-reason></reject-reason>
      </div>
      -->
    </div>
    <div class="reload-button">
      <div class="btn btn-reload bg-red" @click="reload()"><i class="fa fa-refresh" aria-hidden="true"></i></div>
    </div>
  </section>
  <!-- /.content -->
</template>

<script>
import $ from 'jquery'
import Chart from 'chart.js'
import moment from 'moment'
import { mapGetters } from 'vuex'
import datetimePicker from 'vue-datepicker/vue-datepicker-es6.vue'
import OrderLineCharts from '@/components/views/Chart/Temp/OrderLineCharts.vue'
import brandDash from './BrandDashboard.vue'
import systemDash from './SystemDashboard.vue'
import rejectReason from './Dash/RejectReason'
export default {
  components: {
    'date-time-picker': datetimePicker,
    'brand-dashboard': brandDash,
    'system-dashboard': systemDash,
    'reject-reason': rejectReason,
    'order-line-charts': OrderLineCharts
  },
  data () {
    return {
      isMobile: false,
      roleType: 99,
      info: '',
      usersInfo: '',
      disAmount: {
        today: 0,
        total: 0
      },
      ordersAmount: {
        today: {
          amount: 0,
          money: 0
        },
        total: {
          amount: 0,
          money: 0
        }
      },
      successItem: {
        today: 0,
        total: 0
      },
      todaySuccess: 0,
      errorAmount: {
        today: 0,
        total: 0
      },
      shoppersAmount: 0,
      topOrderAmount: {},
      topTradeMoney: {},
      topRejectedMoney: {},
      brandBrief: [],
      storeBrief: [],
      // topBrand
      topBLabels: [],
      topBData: [],
      // topStore
      topSLabels: [],
      topSData: [],
      // allStatistic
      allStatistic: {
        total: {
          amount: 0,
          money: 0
        },
        refuse: {
          amount: 0,
          money: 0
        },
        noAccept: {
          amount: 0,
          money: 0
        },
        accept: {
          amount: 0,
          money: 0
        },
        storeRefuse: {
          amount: 0,
          money: 0
        },
        systemRefuse: {
          amount: 0,
          money: 0
        },
        storeCancel: {
          amount: 0,
          money: 0
        },
        done: {
          amount: 0,
          money: 0
        },
        del: {
          amount: 0,
          money: 0
        }
      },
      schema: {
        noAccept: 100, // 未接單
        accept: 110, // 已接單
        storeRefuse: 120, // 門市拒絕
        systemRefuse: 121, // 系統退訂
        storeCancel: 122, // 店家取消
        done: 130, // 已完成
        del: 140 // 已作廢
      },
      // date
      menuTime: {
        start: {
          time: ''
        },
        end: {
          time: moment().add(1, 'days').format('YYYY-MM-DD')
        }
      },
      dateoption: {
        type: 'day',
        week: ['一', '二', '三', '四', '五', '六', '日'],
        month: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
        format: 'YYYY-MM-DD',
        placeholder: '',
        inputStyle: {
          'display': 'inline-block',
          'padding': '6px',
          'line-height': '22px',
          'font-size': '16px',
          'border': '1px solid #d2d6de',
          'border-radius': '0px 3px 3px 0px',
          'color': '#555'
        },
        color: {
          header: '#dd4b39',
          headerText: '#fff'
        },
        buttons: {
          ok: '確定',
          cancel: '取消'
        },
        overlayOpacity: 0.5, // 0.5 as default
        dismissible: true // as true as default
      },
      startLimit: [
        {
          type: 'fromto',
          to: moment().format('YYYY-MM-DD')
        }
      ],
      endLimit: [
        {
          type: 'fromto',
          to: moment().add(1, 'days').add(1, 'days').format('YYYY-MM-DD')
        }
      ]
    }
  },
  computed: {
    ...mapGetters(['getRoleType', 'getUserId']),
    getDataH () {
      return this.$parent.getDataH
    },
    fixedH () {
      return this.$parent.fixedH
    }
  },
  created () {
    var date = new Date()
    // var y = date.getFullYear()
    // var m = date.getMonth()
    // var firstDay = new Date(y, m, 1)
    this.getSubordinate()
    this.menuTime.start.time = moment(date).add(-30, 'days').format('YYYY-MM-DD')
    this.fixedH()
    let roleType = parseInt(this.getRoleType, 10)
    this.roleType = roleType
    if (roleType === 99) {
      this.initSystem()
    } else if (roleType === 30) this.getBrandBrief()
    else if (roleType === 10) this.getBrandBrief()
  },
  methods: {
    getSubordinate () {
      const self = this
      let roleTypeName = ''
      if (self.getRoleType === 99) {
        roleTypeName = 'admin'
      } else if (self.getRoleType === 30) {
        roleTypeName = 'brand'
      } else if (self.getRoleType === 10) {
        roleTypeName = 'store'
      }
      // 抽成對帳權限開開關
      let url = '/manager/' + roleTypeName + '/' + self.getUserId + '/subordinate'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          let restricList = []
          let denyList = []
          if (response.data.subordinate.allowed_restricted_function_list) {
            restricList = response.data.subordinate.allowed_restricted_function_list
          }
          if (response.data.subordinate.denied_restricted_function_list) {
            denyList = response.data.subordinate.denied_restricted_function_list
          }
          self.$store.commit('SET_RESTRICT', restricList)
          self.$store.commit('SET_DENYLIST', denyList)
        }
      })
    },
    initSystem () {
      const sc = this.schema
      var self = this
      var url = '/statistic/matcher'
      this.topBLabels = []
      this.topBData = []
      this.topSLabels = []
      this.topSData = []
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const info = self.info = response.data.platform_statistic
          self.ordersAmount = info.order_amount
          self.topOrderAmount = info.top_order_amount.total
          for (var b = 0; b < self.topOrderAmount.brand.length; b++) {
            self.topBLabels.push(self.topOrderAmount.brand[b].brand_name)
            self.topBData.push(self.topOrderAmount.brand[b].amount)
          }
          for (var s = 0; s < self.topOrderAmount.store.length; s++) {
            self.topSLabels.push(self.topOrderAmount.store[s].store_name)
            self.topSData.push(self.topOrderAmount.store[s].amount)
          }
          // state = 130 = 成交
          if (info.trade_money.today[sc.done] !== null && typeof (info.trade_money.today[sc.done]) !== 'undefined') {
            self.successItem.today = info.trade_money.today[sc.done].items
          }
          if (info.trade_money.total[sc.done] !== null && typeof (info.trade_money.total[sc.done]) !== 'undefined') {
            self.successItem.total = info.trade_money.total[sc.done].items
          }
          let disAmount = {
            today: 0,
            total: 0
          }
          if (info.trade_money.today[sc.storeRefuse] !== null && typeof (info.trade_money.today[sc.storeRefuse]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeRefuse].money
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeRefuse].money
          }
          if (info.trade_money.today[sc.systemRefuse] !== null && typeof (info.trade_money.today[sc.systemRefuse]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.systemRefuse].money
            disAmount.total = disAmount.total + info.trade_money.total[sc.systemRefuse].money
          }
          if (info.trade_money.today[sc.storeCancel] !== null && typeof (info.trade_money.today[sc.storeCancel]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeCancel].money
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeCancel].money
          }
          if (info.trade_money.today[39] !== null && typeof (info.trade_money.today[39]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[39].money
            disAmount.total = disAmount.total + info.trade_money.total[39].money
          }
          self.disAmount = disAmount
          self.errorAmount.total = info.abnormal_amount.total
          if (info.status_amount.today[sc.accept] !== null && typeof (info.status_amount.today[sc.accept]) !== 'undefined') {
            self.errorAmount.today = info.status_amount.today[sc.accept].amount
          }
          let all = self.allStatistic
          for (let s in sc) {
            let status = sc[s]
            if (info.status_amount.today[status] !== null && typeof (info.status_amount.today[status]) !== 'undefined') {
              all[s].amount = info.status_amount.today[status].amount
              all.total.amount = all.total.amount + info.status_amount.today[status].amount
            }
            if (info.trade_money.today[status] !== null && typeof (info.trade_money.today[status]) !== 'undefined') {
              all[s].money = info.trade_money.today[status].money
              all.total.money = all.total.money + info.trade_money.today[status].money
            }
          }
          all.refuse.amount = all.storeRefuse.amount + all.systemRefuse.amount + all.storeCancel.amount
          all.refuse.money = all.storeRefuse.money + all.systemRefuse.money + all.storeCancel.money
          self.showAllBriefChart()
        }
      })
      var usersUrl = '/statistic/shopper'
      this.getDataH('get', usersUrl, null, function (response) {
        if (response.data.status === 200) {
          const usersInfo = self.usersInfo = response.data.shopper_statistic
          self.shoppersAmount = usersInfo.shopper_amount.total.active
        }
      })
    },
    getBrandBrief () {
      var self = this
      var url = '/brand/listBrief?is_delete=0&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var bList = response.data.list
          var brandIds = ''
          for (let i = 0; i < bList.length; i++) {
            let obj = {label: bList[i].name, value: bList[i].brand_id}
            self.brandBrief.push(obj)
            brandIds = brandIds + bList[i].brand_id + ','
          }
          brandIds = brandIds.slice(0, -1)
          if (bList > 1) self.show.brandDash = false
          if (self.roleType === 30) self.initBrand(brandIds)
          else if (self.roleType === 10) self.getStoreBrief(brandIds)
        }
      })
    },
    getStoreBrief (brandId) {
      this.storeBrief = []
      var self = this
      var url = '/brand/' + brandId + '/storeListBrief?&list_sort=name ASC'
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          var sList = response.data.list
          var storeIds = ''
          for (let i = 0; i < sList.length; i++) {
            let obj = {label: sList[i].name, value: sList[i].store_id}
            self.storeBrief.push(obj)
            storeIds = storeIds + sList[i].store_id + ','
          }
          storeIds = storeIds.slice(0, -1)
          self.initStore(storeIds)
        }
      })
    },
    initBrand (brandIds) {
      const sc = this.schema
      var self = this
      var url = '/statistic/brand?brand_ids=' + brandIds
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const info = self.info = response.data.brand_statistic
          self.ordersAmount = info.order_amount
          self.topOrderAmount = info.top_order_amount.today
          self.topTradeMoney = info.top_trade_money.today
          self.topRejectedMoney = info.top_rejected_money.today
          if (info.trade_money.today[sc.done] !== null && typeof (info.trade_money.today[sc.done]) !== 'undefined') {
            self.successItem.today = info.trade_money.today[sc.done].items
          }
          if (info.trade_money.total[sc.done] !== null && typeof (info.trade_money.total[sc.done]) !== 'undefined') {
            self.successItem.total = info.trade_money.total[sc.done].items
          }
          let disAmount = {
            today: 0,
            total: 0
          }
          if (info.trade_money.today[sc.storeRefuse] !== null && typeof (info.trade_money.today[sc.storeRefuse]) !== 'undefined') {
            // storeRefuse:120:門市拒絕
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeRefuse].money
          }
          if (info.trade_money.total[sc.storeRefuse] !== null && typeof (info.trade_money.total[sc.storeRefuse]) !== 'undefined') {
            // storeRefuse:120:門市拒絕
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeRefuse].money
          }
          if (info.trade_money.today[sc.systemRefuse] !== null && typeof (info.trade_money.today[sc.systemRefuse]) !== 'undefined') {
            // systemRefuse:121:系統退訂
            disAmount.today = disAmount.today + info.trade_money.today[sc.systemRefuse].money
          }
          if (info.trade_money.total[sc.systemRefuse] !== null && typeof (info.trade_money.total[sc.systemRefuse]) !== 'undefined') {
            // systemRefuse:121:系統退訂
            disAmount.total = disAmount.total + info.trade_money.total[sc.systemRefuse].money
          }
          if (info.trade_money.today[sc.storeCancel] !== null && typeof (info.trade_money.today[sc.storeCancel]) !== 'undefined') {
            // systemRefuse:122:店家取消
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeCancel].money
          }
          if (info.trade_money.total[sc.storeCancel] !== null && typeof (info.trade_money.total[sc.storeCancel]) !== 'undefined') {
            // systemRefuse:122:店家取消
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeCancel].money
          }
          /* if (info.trade_money.today[39] !== null && typeof (info.trade_money.today[39]) !== 'undefined') {
            // 39:店家取消,(團長-團員) (流團-揪團失敗)
            disAmount.today = disAmount.today + info.trade_money.today[39].money
          }
          if (info.trade_money.total[39] !== null && typeof (info.trade_money.total[39]) !== 'undefined') {
            // 39:店家取消,(團長-團員) (流團-揪團失敗)
            disAmount.total = disAmount.total + info.trade_money.total[39].money
          } */
          if (info.trade_money.today[sc.del] !== null && typeof (info.trade_money.today[sc.del]) !== 'undefined') {
            // 140:門市作廢,(店家) (已作廢)發票已開出後作廢
            disAmount.today = disAmount.today + info.trade_money.today[sc.del].money
          }
          if (info.trade_money.total[sc.del] !== null && typeof (info.trade_money.total[sc.del]) !== 'undefined') {
            // 140:門市作廢,(店家) (已作廢)發票已開出後作廢
            disAmount.total = disAmount.total + info.trade_money.total[sc.del].money
          }
          self.disAmount = disAmount
          self.errorAmount.total = info.abnormal_amount.total
          if (info.status_amount.today[sc.accept] !== null && typeof (info.status_amount.today[sc.accept]) !== 'undefined') {
            self.errorAmount.today = info.status_amount.today[sc.accept].amount
          }
          let all = self.allStatistic
          for (let s in sc) {
            let status = sc[s]
            if (info.status_amount.today[status] !== null && typeof (info.status_amount.today[status]) !== 'undefined') {
              all[s].amount = info.status_amount.today[status].amount
              all.total.amount = all.total.amount + info.status_amount.today[status].amount
            }
            if (info.trade_money.today[status] !== null && typeof (info.trade_money.today[status]) !== 'undefined') {
              all[s].money = info.trade_money.today[status].money
              all.total.money = all.total.money + info.trade_money.today[status].money
            }
          }
          all.refuse.amount = all.storeRefuse.amount + all.systemRefuse.amount + all.storeCancel.amount
          all.refuse.money = all.storeRefuse.money + all.systemRefuse.money + all.storeCancel.money
          self.showAllBriefChart()
        }
      })
    },
    initStore (storeIds) {
      const sc = this.schema
      var self = this
      var url = '/statistic/store?store_ids=' + storeIds
      this.getDataH('get', url, null, function (response) {
        if (response.data.status === 200) {
          const info = self.info = response.data.store_statistic
          self.ordersAmount = info.order_amount
          self.topOrderAmount = info.top_order_amount
          if (info.trade_money.today[sc.done] !== null && typeof (info.trade_money.today[sc.done]) !== 'undefined') {
            self.successItem.today = info.trade_money.today[sc.done].items
          }
          if (info.trade_money.total[sc.done] !== null && typeof (info.trade_money.total[sc.done]) !== 'undefined') {
            self.successItem.total = info.trade_money.total[sc.done].items
          }
          // state = 120 = 店家退訂
          // state = 121 = 系統退訂
          // state = 122 = 店家幫使用者取消
          // state = 140 = 門市作廢
          // state = 39 = 揪團失敗
          let disAmount = {
            today: 0,
            total: 0
          }
          if (info.trade_money.today[sc.storeRefuse] !== null && typeof (info.trade_money.today[sc.storeRefuse]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeRefuse].money
          }
          if (info.trade_money.total[sc.storeRefuse] !== null && typeof (info.trade_money.total[sc.storeRefuse]) !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeRefuse].money
          }
          if (info.trade_money.today[sc.systemRefuse] !== null && typeof (info.trade_money.today[sc.systemRefuse]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.systemRefuse].money
          }
          if (info.trade_money.total[sc.systemRefuse] !== null && typeof (info.trade_money.total[sc.systemRefuse]) !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.systemRefuse].money
          }
          if (info.trade_money.today[sc.storeCancel] !== null && typeof (info.trade_money.today[sc.storeCancel]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[sc.storeCancel].money
          }
          if (info.trade_money.total[sc.storeCancel] !== null && typeof (info.trade_money.total[sc.storeCancel]) !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[sc.storeCancel].money
          }
          if (info.trade_money.today[39] !== null && typeof (info.trade_money.today[39]) !== 'undefined') {
            disAmount.today = disAmount.today + info.trade_money.today[39].money
          }
          if (info.trade_money.total[39] !== null && typeof (info.trade_money.total[39]) !== 'undefined') {
            disAmount.total = disAmount.total + info.trade_money.total[39].money
          }
          self.disAmount = disAmount
          self.errorAmount.total = info.abnormal_amount.total
          if (info.status_amount.today[sc.accept] !== null && typeof (info.status_amount.today[sc.accept]) !== 'undefined') {
            self.errorAmount.today = info.status_amount.today[sc.accept].amount
          }
          let all = self.allStatistic
          for (let s in sc) {
            let status = sc[s]
            if (info.status_amount.today[status] !== null && typeof (info.status_amount.today[status]) !== 'undefined') {
              all[s].amount = info.status_amount.today[status].amount
              all.total.amount = all.total.amount + info.status_amount.today[status].amount
            }
            if (info.trade_money.today[status] !== null && typeof (info.trade_money.today[status]) !== 'undefined') {
              all[s].money = info.trade_money.today[status].money
              all.total.money = all.total.money + info.trade_money.today[status].money
            }
          }
          all.refuse.amount = all.storeRefuse.amount + all.systemRefuse.amount + all.storeCancel.amount
          all.refuse.money = all.storeRefuse.money + all.systemRefuse.money + all.storeCancel.money
          self.showAllBriefChart()
        }
      })
    },
    showTopChart () {
      var ctx = document.getElementById('today-brand-top').getContext('2d')
      var config = {
        type: 'pie',
        data: {
          datasets: [{
            data: this.topBData,
            backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
          }],
          // These labels appear in the legend and in the tooltips when hovering different arcs
          labels: this.topBLabels
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          },
          tooltips: {
            mode: 'label',
            xPadding: 10,
            yPadding: 10,
            bodySpacing: 10
          }
        }
      }
      new Chart(ctx, config) // eslint-disable-line no-new

      var ctx2 = document.getElementById('today-store-top').getContext('2d')
      var config2 = {
        type: 'pie',
        data: {
          datasets: [{
            data: this.topSData,
            backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
          }],
          // These labels appear in the legend and in the tooltips when hovering different arcs
          labels: this.topSLabels
        },
        options: {
          responsive: true,
          maintainAspectRatio: !this.isMobile,
          legend: {
            position: 'bottom',
            display: true
          },
          tooltips: {
            mode: 'label',
            xPadding: 10,
            yPadding: 10,
            bodySpacing: 10
          }
        }
      }
      new Chart(ctx2, config2) // eslint-disable-line no-new
    },
    showAllBriefChart () {
      this.$nextTick(() => {
        const all = this.allStatistic
        var ctx = document.getElementById('all-amount-brief').getContext('2d')
        let data = []
        data.push(all.noAccept.amount)
        data.push(all.accept.amount)
        data.push(all.refuse.amount)
        data.push(all.done.amount)
        data.push(all.del.amount)
        var config = {
          type: 'pie',
          data: {
            datasets: [{
              data: data,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],
            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: ['未接單', '已接單', '被退訂', '已完成', '已作廢']
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        new Chart(ctx, config) // eslint-disable-line no-new

        var ctx2 = document.getElementById('all-money-brief').getContext('2d')
        let data2 = []
        data2.push(all.noAccept.money)
        data2.push(all.accept.money)
        data2.push(all.refuse.money)
        data2.push(all.done.money)
        data2.push(all.del.money)
        var config2 = {
          type: 'pie',
          data: {
            datasets: [{
              data: data2,
              backgroundColor: ['#dd4b39', '#f39c12', '#00c0ef', '#00a65a', '#337ab7']
            }],
            // These labels appear in the legend and in the tooltips when hovering different arcs
            labels: ['未接單', '已接單', '被退訂', '已完成', '已作廢']
          },
          options: {
            responsive: true,
            maintainAspectRatio: !this.isMobile,
            legend: {
              position: 'bottom',
              display: true
            },
            tooltips: {
              mode: 'label',
              xPadding: 10,
              yPadding: 10,
              bodySpacing: 10
            }
          }
        }
        new Chart(ctx2, config2) // eslint-disable-line no-new
      })
    },
    handelResize () {
      var self = this
      var w = $(window).innerWidth()
      if (w >= 1000) self.isMobile = false
      else self.isMobile = true
    },
    reload () {
      window.location.reload()
    }
  },
  beforeDestory () {
    $(window).off('resize')
  },
  mounted () {
    var self = this
    this.handelResize()
    $(window).resize(function () {
      self.handelResize()
    })
  },
  watch: {
    'menuTime.end.time' () {
      var lastDay = moment(this.menuTime.end.time, 'YYYY-MM-DD').add(1, 'days').format('YYYY-MM-DD')
      if (this.menuTime.start.time > lastDay) this.menuTime.start.time = lastDay
      this.startLimit = [
        {
          type: 'fromto',
          to: lastDay
        }
      ]
    },
    'menuTime.start.time' () {
      var lastDay = moment(this.menuTime.start.time).add('31', 'days')
      if (lastDay < moment()) this.menuTime.end.time = lastDay.format('YYYY-MM-DD')
      else this.menuTime.end.time = moment().format('YYYY-MM-DD')
      this.endLimit = [
        {
          type: 'fromto',
          from: moment(this.menuTime.start.time).subtract(1, 'days'),
          to: moment(this.menuTime.end.time).add(1, 'days')
        }
      ]
    }
  }
}
</script>
<style lang="sass">
.reload-button
  position: fixed
  z-index: 1000
  bottom: 30px
  right: 20px
  .btn-reload
    border-radius: 50%
    height: 45px
    width: 45px
    font-size: 23px
.p-l-10
  padding-left: 10px !important
.p-r-10
  padding-right: 10px !important
.line-canvas
  min-height: 250px
  height: auto !important
  width: 100% !important
.box-body.p-0
  padding: 0px
.info-box
  cursor: pointer
.info-box-content
  text-align: center
  vertical-align: middle
  display: inherit
.fullCanvas
  width: 100%
.info-box-content
  white-space: nowrap
  text-overflow: ellipsis
  overflow: hidden
@media (min-width: 992px)
  .col-md-20-p
    width: 20%
    float: left
</style>
<style lang="sass" scoped>
@media (min-width: 1200px)
  .info-box-icon
    width: 40px
    font-size: 25px
  .info-box-content
    margin-left: 40px
  .col-lg-20-p
    width: 20%
</style>



// WEBPACK FOOTER //
// Dashboard.vue?0de83afb